module.exports = __webpack_public_path__ + "media/SAF-1000_Ares_MobileDevicesAndRemoteSecurity_2025.d767c9ae.mp4";